import { Component } from '@angular/core';
import { IonicPage, NavController
         ,NavParams,LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
//types
import { LoginInfo,WalletViewModel } from '../model/types';
import { Http, Headers, RequestOptions,Response } from '@angular/http';
//page
import { MenuPage } from '../menu/menu'

//service
import { AppSharedService } from '../service/app_shared';

@Component({
  selector: 'page-wallet',
  templateUrl: 'wallet.html',
})
export class WalletPage {

  walletInfo:WalletViewModel;

  constructor(public navCtrl: NavController
            ,public navParams: NavParams
            ,private http : Http
            ,private storage: Storage
            ,private loadingCtrl : LoadingController,
            private appSharedService:AppSharedService) {

              this.walletInfo={
                  walletBalance:'0.00',
                  walletDetail:[]
               };

             this.getWalletDetails();
  }

  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }

  getWalletDetails(){

    let loading = this.loadingCtrl.create({
          content: 'Please wait...'
    });

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

    if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
      
    // create error
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});

      var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlWallet);
      
      //show loader
      loading.present();

      this.http.get(url,options)
        .subscribe((res: Response) => {   
              if(res.status==200){
                this.walletInfo= JSON.parse(res.text()) as WalletViewModel;

                //dismiss loader
                loading.dismiss();
              }else{        

                // dismiss loader
                loading.dismiss();
              }
          });
          }
      });
}

walletOptChnage(){

}

ionViewDidLoad() {
  
}
}



// WEBPACK FOOTER //
// ./src/pages/wallet/wallet.ts